<template>
    <div class="d-flex flex-grow-1 flex-shrink-0 flex-column">
        <v-card class="elevation-1">
            <v-card-title>
                <span class="font-weight-bold">
                    Valutazione degli errori di arrotondamento
                </span> 
            </v-card-title>
            <v-card-text class="ma-2">
                L’errore di arrotondamento, intrinseco negli indicatori digitali, 
                deve essere eliminato se l’intervallo di divisione (d) è più grande di 0,2 e.<br/>
                In questi casi si possono utilizzare uno dei seguenti metodi:
                <ol class="pt-2">
                    <li>Se possibile, la massa del carico di prova deve essere selezionata per eliminare
                    l’errore di arrotondamento secondo la seguente logica: <br/>
                        <ol type="a">
                            <li> Se l’errore massimo permesso = 1,5 e (o 0,5 e, 2,5 e, ecc.) il valore della massa del carico 
                            di prova deve essere selezionata il più vicino possibile all’unità dell’intervallo di divisione; </li>
                            <li> Se l’errore massimo permesso = 1,0 e (o 2,0 e, 3,0 e, ecc.) il valore della massa del carico di prova
                            deve essere selezionata il più vicino possibile all’unità dell’intervallo di divisione aggiungendo (o sottraendo) 0,5 e</li>
                        </ol>
                    </li>
                    <li>Se il punto 1 non è applicabile, l’errore di arrotondamento deve essere preso in considerazione 
                    aggiungendo 0,5 e all’errore massimo permesso specificato</li>
                </ol>
            </v-card-text>
        </v-card>
        <v-card class="elevation-1">
            <v-card-title primary-title>
                <span class="font-weight-bold">
                    Tabella riassuntiva valori: <span v-if="data.selected_mode == 'service'">IN SERVICE</span><span v-else>INSTALLATION</span>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="4" class="pr-4">
                        <v-simple-table class="measure_table">
                            <template v-slot:default>
                                <thead class="expansion">
                                <tr>
                                    <th class="table-text-blocks text-center">Valore MPE</th>
                                </tr>
                                </thead>
                                <tr v-for="(item,index) of current_MPE" :key="index">
                                    <td class="text-center">{{item}} {{currentMinDiv}}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="1" class="text-center">
                    <v-divider vertical/>
                    </v-col>
                    <v-col cols="7" class="pl-4">
                        <v-simple-table class="measure_table">
                                <template v-slot:default>
                                    <thead class="expansion">
                                    <tr>
                                        <th class="table-text-blocks text-center">Valore carico netto</th>
                                        <th class="table-text-blocks text-center">deviazione standard permessa</th>
                                    </tr>
                                </thead>
                                <tr v-for="(item,index) of current_stdev" :key="index">
                                    <td class="text-center">
                                        {{item.range}}
                                    </td> 
                                    <td class="text-center">
                                        {{item.value}}
                                    </td>
                                <tr/>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    props: ['data'],
    data() {
        return {
            measures: {
                result: "done"
            },
            MPEinService: [1,2,3],
            MPEinInstallation: [0.5,1,1.5],
            stdev_inService: [
                {range: "m <= 50g", value: "0.60%"},
                {range: "50g < m <= 100g", value: "0.3g"},
                {range: "100g < m <= 200g", value: "0.30%"},
                {range: "200g < m <= 300g", value: "0.6"},
                {range: "300g < m <= 500g", value: "0.20%"},
                {range: "500g < m <= 1000g", value: "1"},
                {range: "1000g < m <= 10000g", value: "0.10%"},
                {range: "10000g < m <= 15000g", value: "10"},
                {range: "15000g <= m", value: "0.067%"}
            ],
            stdev_inInstallation: [
                {range: "m <= 50g", value: "0.48%"},
                {range: "50g < m <= 100g", value: "0.24"},
                {range: "100g < m <= 200g", value: "0.24%"},
                {range: "200g < m <= 300g", value: "0.48"},
                {range: "300g < m <= 500g", value: "0.16%"},
                {range: "500g < m <= 1000g", value: "0.8"},
                {range: "1000g < m <= 10000g", value: "0.08%"},
                {range: "10000g < m <= 15000g", value: "8"},
                {range: "15000g <= m", value: "0.053%"} 
            ]
        }
    },
    methods: {
        saveMeasures() {
            this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id})
        },
    },
    computed: {
        current_stdev(){
            if(this.data.selected_mode == "service"){
                return this.stdev_inService
            } else {
                return this.stdev_inInstallation
            }
        },
        current_MPE(){
            if(this.data.selected_mode == "service"){
                return this.MPEinService
            } else {
                return this.MPEinInstallation
            }
        },
        currentMinDiv(){
            console.log("$$ debug data in selected mode", this.data)
            if(this.data.instrument_data.instrument_class){
                return "e"
            } else {
                return "d"
            }
        }
        
    },
    beforeMount() {
        this.saveMeasures()
    },
}
</script>